// Phase HR-004 Wave 2 — 3-way attendance reconciliation API client.
import apiClient from '@/shared/api/client'

export type ReconciliationStatus =
  | 'NOT_RECONCILED' | 'OK' | 'DISCREPANCY_PENDING'
  | 'GM_APPROVED' | 'HR_APPROVED' | 'FULLY_APPROVED' | 'REJECTED'

export type DiscrepancyType =
  | 'BIOMETRIC_NO_ALLOCATION'
  | 'ALLOCATION_NO_BIOMETRIC'
  | 'MANUAL_NO_BIOMETRIC'
  | 'BIOMETRIC_NO_MANUAL'
  | 'ALLOCATION_NO_MANUAL'
  | 'MIXED'

export interface ReconQueueRow {
  id: string
  attendance_date: string
  employee_id: string
  emp_code: string | null
  employee_name: string | null
  department_id: string | null
  department_name: string | null
  shift_id: string | null
  shift_code: string | null
  manual_status: string
  biometric_punched: boolean
  biometric_first_in: string | null
  biometric_last_out: string | null
  allocation_id: string | null
  allocation_machine_id: string | null
  allocation_role: string | null
  reconciliation_status: ReconciliationStatus
  discrepancy_type: DiscrepancyType | null
  discrepancy_at: string | null
  gm_approval_at: string | null
  gm_approval_by_name: string | null
  hr_approval_at: string | null
  hr_approval_by_name: string | null
  approval_reason: string | null
  rejection_reason: string | null
}

export interface ReconStats {
  total: number
  pending: number
  gm_only_approved: number
  hr_only_approved: number
  by_discrepancy_type: Record<string, number>
}

export interface ReconRunResult {
  date: string
  ok: number
  discrepancy_pending: number
  stub_created: number
  already_finalised: number
  skipped_locked: number
}

const BASE = '/hr/reconciliation'

export const reconciliationApi = {
  run: async (params: { on_date: string; plant_id?: string; employee_id?: string }) =>
    (await apiClient.post<ReconRunResult>(`${BASE}/run`, null, { params })).data,

  queue: async (params?: {
    plant_id?: string; on_date?: string
    status_in?: ReconciliationStatus[]
    department_id?: string; discrepancy_type?: DiscrepancyType
    limit?: number
  }) => (await apiClient.get<ReconQueueRow[]>(`${BASE}/queue`, { params })).data,

  stats: async (params?: { plant_id?: string; on_date?: string }) =>
    (await apiClient.get<ReconStats>(`${BASE}/stats`, { params })).data,

  approveGm: async (attendance_id: string, reason: string) =>
    (await apiClient.post(`${BASE}/${attendance_id}/approve-gm`, { reason })).data,

  approveHr: async (attendance_id: string, reason: string) =>
    (await apiClient.post(`${BASE}/${attendance_id}/approve-hr`, { reason })).data,

  reject: async (attendance_id: string, reason: string) =>
    (await apiClient.post(`${BASE}/${attendance_id}/reject`, { reason })).data,
}
